const combineResults = [
  {
    name: "40 Yard dash",
    description:
      "This is a test of speed and power. From a three-point stance, a player runs 40 yards as fast as he can. Split times are recorded at 10 and 20 yards to measure acceleration. The 10-yard time is especially important for offensive and defensive linesmen because they usually don't run further than that during a play.",
    unit: "seconds",
    attempt: 1,
    test: [
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: 10,
        stageLabel: true,
        name: "stageValue",
        fieldId: 1,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: 20,
        stageLabel: true,
        name: "stageValue",
        fieldId: 2,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: 40,
        stageLabel: true,
        name: "stageValue",
        fieldId: 3,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,

        subFields: {
          topSpeed: {
            auxKey: "auxiliary1",
            label: "Top mph",
            step: "0.001",
          },
        },
      },
    ],
  },
  {
    name: "40 Yard dash",
    description:
      "This is a test of speed and power. From a three-point stance, a player runs 40 yards as fast as he can. Split times are recorded at 10 and 20 yards to measure acceleration. The 10-yard time is especially important for offensive and defensive linesmen because they usually don't run further than that during a play.",
    unit: "seconds",
    attempt: 2,
    test: [
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: 10,
        stageLabel: true,
        name: "stageValue",
        fieldId: 4,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: 20,
        stageLabel: true,
        name: "stageValue",
        fieldId: 5,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: 40,
        stageLabel: true,
        name: "stageValue",
        fieldId: 6,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,

        subFields: {
          topSpeed: {
            auxKey: "auxiliary1",
            label: "Top mph",
            step: "0.001",
          },
        },
      },
    ],
  },
  {
    name: "Bench press",
    description:
      "The bench press test is a test of upper body strength. Each player must bench press 225 lbs. as many times as they can. Quarterbacks and wide receivers are exempt from the test. The bench press is the most important for offensive and defensive linemen. - it is planned to remove the bench press test from the player assessments",
    unit: "lbs",
    attempt: 1,
    test: [
      {
        stageAsField: true,
        fieldPlaceHolder: "lbs",
        stage: "",
        stageLabel: false,
        name: "reps",
        fieldId: 7,
        type: "number",
        placeholder: "reps",
        step: "1",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
    ],
  },
  {
    name: "Vertical jump",
    description:
      "A test of explosion and power. The player jumps off both feet straight up as high as he can. The vertical jump is most important for receivers and defensive backs.",
    unit: "inches",
    attempt: 1,
    test: [
      {
        stageAsField: true,
        fieldPlaceHolder: "in",
        stage: "",
        stageLabel: false,
        name: "stageValue",
        fieldId: 9,
        type: "number",
        placeholder: "in",
        step: "0.001",
        aux: true,
        readOnly: true,
        videoId: 1,
      },
    ],
  },
  {
    name: "Broad jump",
    description:
      "Similar to the vertical jump, this is a test of lower body strength, explosion, and power. The broad jump measures how far you can jump, not how high. From a standing position, the player jumps forward off two feet as far as he can. The broad jump is the most important for running backs, linemen, and linebackers.",
    unit: "inches",
    attempt: 1,
    test: [
      {
        stageAsField: true,
        fieldPlaceHolder: "ft",
        stage: "",
        stageLabel: false,
        name: "stageValue",
        fieldId: 11,
        type: "number",
        placeholder: "in",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
    ],
  },
  // {
  //   name: "Broad jump",
  //   description:
  //     "Similar to the vertical jump, this is a test of lower body strength, explosion, and power. The broad jump measures how far you can jump, not how high. From a standing position, the player jumps forward off two feet as far as he can. The broad jump is the most important for running backs, linemen, and linebackers.",
  //   unit: "inches",
  //   attempt: 2,
  //   test: [
  //     {
  //       stageAsField: true,
  //       fieldPlaceHolder: "ft",
  //       stage: "",
  //       stageLabel: false,
  //       name: "stageValue",
  //       fieldId: 12,
  //       type: "number",
  //       placeholder: "in",
  //       step: "0.001",
  //       aux: false,
  //       readOnly: false,
  //       videoId: 1,
  //     },
  //   ],
  // },
  {
    name: "20-yard shuttle (5-10-5)",
    description:
      "Also called the 5-10-5 Shuttle, this is a test of agility including speed, explosion and changing of directions. Technique is also important. Each player will be timed how fast they can go 5 yards laterally, then 10 back in the opposite direction, and finishing 5 yards back to the start line.",
    unit: "seconds",
    attempt: 1,
    test: [
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: "",
        stageLabel: false,
        name: "stageValue",
        fieldId: 13,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
    ],
  },
  {
    name: "20-yard shuttle (5-10-5)",
    description:
      "Also called the 5-10-5 Shuttle, this is a test of agility including speed, explosion and changing of directions. Technique is also important. Each player will be timed how fast they can go 5 yards laterally, then 10 back in the opposite direction, and finishing 5 yards back to the start line.",
    unit: "seconds",
    attempt: 2,
    test: [
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: "",
        stageLabel: false,
        name: "stageValue",
        fieldId: 14,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
    ],
  },
  {
    name: "Three-cone drill (L-drill)",
    description:
      'This is an agility test where the players runs around three cones placed in the shape of an "L". There are 5 yards between each cone.',
    unit: "seconds",
    attempt: 1,
    test: [
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: "",
        stageLabel: false,
        name: "stageValue",
        fieldId: 15,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
    ],
  },
  {
    name: "Three-cone drill (L-drill)",
    description:
      'This is an agility test where the players runs around three cones placed in the shape of an "L". There are 5 yards between each cone.',
    unit: "seconds",
    attempt: 2,
    test: [
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: "",
        stageLabel: false,
        name: "stageValue",
        fieldId: 16,
        type: "number",
        placeholder: "0.000",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
    ],
  },
  {
    name: "Kicker Charting",
    description: "",
    unit: "",
    attempt: 1,
    test: [
      {
        stageAsField: false,
        fieldPlaceHolder: "",
        stage: "",
        stageLabel: false,
        name: "stageValue",
        fieldId: 19,
        type: "number",
        placeholder: "0",
        step: "1",
        max: 10,
        aux: false,
        readOnly: false,
        videoId: 1,
      },
    ],
  },
  {
    name: "Med Ball",
    description: "",
    unit: "inches",
    attempt: 1,
    test: [
      {
        stageAsField: true,
        fieldPlaceHolder: "ft",
        stage: "",
        stageLabel: false,
        name: "stageValue",
        fieldId: 17,
        type: "number",
        placeholder: "in",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
    ],
  },
  {
    name: "Med Ball",
    description: "",
    unit: "inches",
    attempt: 2,
    test: [
      {
        stageAsField: true,
        fieldPlaceHolder: "ft",
        stage: "",
        stageLabel: false,
        name: "stageValue",
        fieldId: 18,
        type: "number",
        placeholder: "in",
        step: "0.001",
        aux: false,
        readOnly: false,
        videoId: 1,
      },
    ],
  },
];

export default combineResults;
